import { render, staticRenderFns } from "./Particulars.vue?vue&type=template&id=b18f0a74&scoped=true&"
import script from "./Particulars.vue?vue&type=script&lang=js&"
export * from "./Particulars.vue?vue&type=script&lang=js&"
import style0 from "./Particulars.vue?vue&type=style&index=0&id=b18f0a74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18f0a74",
  null
  
)

export default component.exports